import React, {useState} from "react";
import {FieldErrors, useFormContext} from "react-hook-form";
import RegistrationModel from "../model/RegistrationModel";
import {
  FIRST_NAME_MAX_LENGTH,
  LAST_NAME_MAX_LENGTH,
  MINIMUM_AGE
} from "../../NewResearcherConstants";
import Text from "../../../../framework/component/form/input-types/Text";
import Dropdown from "../../../../framework/component/form/input-types/Dropdown";
import DatePicker from "../../../../framework/component/form/input-types/DatePicker";

/**
 * This component represents the part of the registration form related to personal information
 */
export default function PersonalInformation() {
  const [titleList, setTitleList] = useState<{ key: string | number, label: string }[]>([]);
  const [genderList, setGenderList] = useState<{ key: string | number, label: string }[]>([]);
  const {formState: {errors}} = useFormContext<RegistrationModel>();

  // We lazy load the dropdowns
  const loadTitleList = () => {
    // TODO load from backend
    setTitleList([
      {key: "Doctor", label: "Doctor"},
      {key: "Mrs", label: "Mrs"},
      {key: "Mr", label: "Mr"},
      {key: "Ms", label: "Ms"},
      {key: "Miss", label: "Miss"},
      {key: "Professor", label: "Professor"},
      {key: "Sir", label: "Sir"},
      {key: "Mx", label: "Mx"}
    ]);
  }
  const loadGenderList = () => {
    // TODO load from backend
    setGenderList([
      {key: "MALE", label: "Male"},
      {key: "FEMALE", label: "Female"},
      {key: "NOT_SAY", label: "Prefer not to say"}
    ]);
  }

  return <>
    {/*Title*/}
    <Dropdown<RegistrationModel>
        label={"Title"}
        content={titleList}
        lazyLoadTrigger={loadTitleList}
        error={errors.personalInfo?.title}
        fieldId={"personalInfo.title"}
        mandatory/>
    {/*Last Name*/}
    <Text<RegistrationModel>
        label={"Last Name"}
        error={errors.personalInfo?.lastName}
        fieldId={"personalInfo.lastName"}
        mandatory
        maxLength={LAST_NAME_MAX_LENGTH}
        customValidation={(v) => {
          return v?.trim().length ? true : "Last Name cannot be empty"
        }}/>
    {/*First Name*/}
    <Text<RegistrationModel>
        label={"First Name"}
        error={errors.personalInfo?.firstName}
        fieldId={"personalInfo.firstName"}
        mandatory
        maxLength={FIRST_NAME_MAX_LENGTH}
        customValidation={(v) => {
          return v?.trim().length ? true : "Last Name cannot be empty"
        }}/>
    {/*Middle Name*/}
    <Text<RegistrationModel>
        label={"Middle Name"}
        error={errors.personalInfo?.middleName}
        fieldId={"personalInfo.middleName"}/>
    {/*Date of Birth*/}
    <DatePicker<RegistrationModel>
        label={"Date of Birth"}
        error={errors.personalInfo?.dateOfBirth}
        fieldId={"personalInfo.dateOfBirth"}
        customValidation={(value) => {
          // Allow empty (optional field)
          if (!value) return true;

          // Validate the researcher is minimum age
          const today = new Date();
          const minAgeDate = new Date(
              today.getFullYear() - MINIMUM_AGE,
              today.getMonth(),
              today.getDate()
          );
          const inputDate = new Date(value);
          return inputDate <= minAgeDate || `You must be at least ${MINIMUM_AGE} years old`;
        }
        }
        mandatory
    />
    {/*Gender*/}
    <Dropdown<RegistrationModel>
        label={"Gender"}
        content={genderList}
        lazyLoadTrigger={loadGenderList}
        error={errors.personalInfo?.gender}
        fieldId={"personalInfo.gender"}/>
  </>
}